import React from "react";
import axios from "axios";
import Spinner from "../../components/Spinner";
import Banner from "../../components/Banner";

const API = localStorage.getItem("assethost");

// Helper regex and constants, all in this file
const phoneRegex =
  /^\+?[0-9]{1,4}?[-.\s]?\(?[0-9]{1,3}?\)?[-.\s]?[0-9]{3,4}[-.\s]?[0-9]{3,4}$/;
const phoneError = "Not a valid phone number";

export default class Balance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      msg: "",
      toastColor: "",
      fullname: "",
      bundleName: "",
      credits: 0,
      cost: 0,
      used: 0,
      expiryDate: "",
      showTopup: false,
      topupBundleName: "",
      topupCredits: "",
      topupCost: "",
      topupCurrency: "",
      topupExpiryInDays: "",
      topupMobileMoneyNumber: "",
      topupMobileMoneyName: "",
      topupErrors: {},
      pollRefId: "",
      pollStatus: "",
      pollMessage: "",
      pollInterval: null,
      individualProfileId: sessionStorage.getItem("individualProfileId") || "",
      bundles: [],
      mobileMoneyNumber: "",
      mobileMoneyTypes: [],
    };
    this.loadBalance = this.loadBalance.bind(this);
    this.loadTopupDropdownList = this.loadTopupDropdownList.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleTopupToggle = this.handleTopupToggle.bind(this);
    this.handleTopupChange = this.handleTopupChange.bind(this);
    this.handleTopupSubmit = this.handleTopupSubmit.bind(this);
    this.validateTopup = this.validateTopup.bind(this);
    this.startPolling = this.startPolling.bind(this);
    this.stopPolling = this.stopPolling.bind(this);
    this.pollTransaction = this.pollTransaction.bind(this);
    this.handleCheckStatus = this.handleCheckStatus.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    this.setState({
      fullname: sessionStorage.getItem("fullname") || "",
    });
    if (!token) {
      this.setState({
        loading: false,
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${window.location.pathname + window.location.search
        }`;
      return;
    }
    if (!this.state.individualProfileId) {
      this.setState({
        loading: false,
        error: "No individual profile ID. Please check your account.",
        msg: "No Profile ID",
        toastColor: "danger",
      });
      return;
    }
    this.loadBalance();
  }

  loadBalance() {
    this.setState({ loading: true, msg: "", toastColor: "" });
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${window.location.pathname + window.location.search
        }`;
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + `/billing/getbalance/${this.state.individualProfileId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        this.setState({
          loading: false,
          error: null,
          bundleName: data.bundleName || "",
          credits: data.credits || 0,
          cost: data.cost || 0,
          used: data.used || 0,
          expiryDate: data.expiryDate || "",
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        this.setState({
          loading: false,
          error: error?.response?.data?.message || "Failed to load balance.",
          msg: error?.response?.data?.message || "Failed to load balance.",
          toastColor: "danger",
        });
      });
  }

  loadTopupDropdownList() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${window.location.pathname + window.location.search
        }`;
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(
        API + `/payment/gettopupdropdownlist/${this.state.individualProfileId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        const data = response.data || {};
        this.setState({
          loading: false,
          bundles: data.bundles,
          mobileMoneyNumber: data.mobileMoneyNumber,
          mobileMoneyTypes: data.mobileMoneyTypes,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        this.setState({
          loading: false,
          error:
            error?.response?.data?.message || "Failed to load dropdown lists.",
          msg:
            error?.response?.data?.message || "Failed to load dropdown lists.",
          toastColor: "danger",
        });
      });
  }

  handleRefresh() {
    this.loadBalance();
  }

  handleTopupToggle() {
    const isOpen = this.state.showTopup;
    this.setState({
      showTopup: !isOpen,
      ...(isOpen
        ? {}
        : {
          topupErrors: {},
          pollRefId: "",
          pollStatus: "",
          pollMessage: "",
          topupCost: "",
          topupCredits: 0,
          topupCurrency: "",
          topupBundleName: "",
          topupExpiryInDays: 0,
          msg: "",
        }),
    });
    if (!isOpen) {
      this.loadTopupDropdownList();
      this.validateTopup();
    } else {
      this.stopPolling();
    }
  }

  handleTopupChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validateTopup);
  }

  handleSelectChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  validateTopup() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (!s.topupBundleName.trim()) {
      errors.topupBundleName = "Bundle Name is required";
      valid = false;
    }
    if (!s.topupCredits) {
      errors.topupCredits = "Credits is required. Select bundle name.";
      valid = false;
    } else if (
      isNaN(parseFloat(s.topupCredits)) ||
      parseFloat(s.topupCredits) <= 0
    ) {
      errors.topupCredits = "Credits must be greater than 0";
      valid = false;
    }
    if (!s.topupCost) {
      errors.topupCost = "Cost is required. Select bundle name.";
      valid = false;
    } else if (isNaN(parseFloat(s.topupCost)) || parseFloat(s.topupCost) <= 0) {
      errors.topupCost = "Cost must be greater than 0";
      valid = false;
    }
    if (!s.topupCurrency.trim()) {
      errors.topupCurrency = "Currency is . Select bundle name.";
      valid = false;
    }
    if (!s.topupExpiryInDays) {
      errors.topupExpiryInDays =
        "Expiry in Days is required. Select bundle name.";
      valid = false;
    } else if (
      isNaN(parseInt(s.topupExpiryInDays)) ||
      parseInt(s.topupExpiryInDays) <= 0
    ) {
      errors.topupExpiryInDays = "Expiry in Days must be greater than 0";
      valid = false;
    }
    if (!s.topupMobileMoneyNumber.trim()) {
      errors.topupMobileMoneyNumber = "Mobile Money Number is required";
      valid = false;
    } else if (!phoneRegex.test(s.topupMobileMoneyNumber)) {
      errors.topupMobileMoneyNumber = phoneError;
      valid = false;
    }
    if (!s.topupMobileMoneyName.trim()) {
      errors.topupMobileMoneyName = "Mobile Money Name is required";
      valid = false;
    }

    this.setState({ topupErrors: errors });
    return valid;
  }

  handleTopupSubmit(e) {
    e.preventDefault();
    if (!this.validateTopup()) {
      this.setState({
        msg: "Fix the errors in the form and try again.",
        toastColor: "danger",
      });
      return;
    }
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });
    const topupData = {
      individualProfileId: parseInt(this.state.individualProfileId),
      bundleName: this.state.topupBundleName,
      credits: this.state.topupCredits,
      cost: this.state.topupCost,
      currency: this.state.topupCurrency,
      expiryInDays: parseInt(this.state.topupExpiryInDays),
      mobileMoneyNumber: this.state.topupMobileMoneyNumber,
      mobileMoneyName: this.state.topupMobileMoneyName,
    };
    axios
      .post(API + "/payment/topupaccount", topupData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        if (data.success) {
          this.setState({
            showTopup: false,
            pollRefId: data.refId || "",
            loading: false,
          });
          this.startPolling(data.refId);
          this.setState({
            msg: "Topup initiated. Polling for confirmation...",
            pollMessage: "Topup initiated. Polling for confirmation...",
            toastColor: "success",
          });
        } else {
          this.setState({
            loading: false,
            msg: data.message || "Topup failed.",
            toastColor: "danger",
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        this.setState({
          loading: false,
          msg:
            error?.response?.data?.message || "Topup failed. Please try again.",
          toastColor: "danger",
        });
      });
  }

  startPolling(refId) {
    const interval = setInterval(() => {
      this.pollTransaction(refId);
    }, 5000); // Poll every 5 seconds
    this.setState({ pollInterval: interval });
  }

  stopPolling() {
    if (this.state.pollInterval) {
      clearInterval(this.state.pollInterval);
      this.setState({ pollInterval: null });
    }
  }

  pollTransaction(refId) {
    this.setState({ msg: "", toastColor: "" });
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      return;
    }
    axios
      .get(API + `/payment/polltransaction/${refId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const data = response.data || {};
        this.setState({ pollStatus: data.pollStatus || "PENDING" });
        if (data.pollStatus !== "CREATED") {
          this.stopPolling();
          if (data.pollStatus === "SUCCESS") {
            this.setState({
              pollStatus: "",
              msg: "Topup confirmed!",
              pollMessage: "Topup confirmed!",
              toastColor: "success",
              loading: false,
            });
            this.loadBalance(); // Refresh balance
          } else if (data.pollStatus === "FAILED") {
            this.setState({
              pollStatus: "",
              msg: data.message || "Topup failed!",
              pollMessage: data.message || "Topup failed!",
              toastColor: "danger",
              loading: false,
            });
          } else {
            this.setState({
              pollStatus: "",
              msg: `Transaction status: ${data.pollStatus}`,
              pollMessage: `Transaction status: ${data.pollStatus}`,
              toastColor: "warning",
              loading: false,
            });
          }
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        this.setState({
          pollStatus:
            "Polling error: " +
            (error?.response?.data?.message || "Unknown error"),
          loading: false,
        });
        // Continue polling on error
      });
  }

  handleCheckStatus() {
    if (this.state.pollRefId) {
      this.pollTransaction(this.state.pollRefId);
    } else {
      this.setState({
        msg: "No transaction to check.",
        toastColor: "warning",
      });
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.pollInterval) {
      divMsg = (
        <div className="position-fixed top-0 bottom-0 start-0 end-0 bg-transparent bg-opacity-50 d-flex align-items-start justify-content-center z-3">
          <div className="bg-white border border-primary rounded-bottom w-99 h-5-6 overflow-auto d-flex flex-column px-5">
            <Banner key={`poll-message-banner`} title="Topup status" />
            <div className="d-flex flex-column align-items-center justify-content-center flex-grow-1">
              <div className="alert alert-info mx-5 w-100">
                <div className="d-flex align-items-center gap-2">
                  <div className="w-1rem h-1rem" style={{ marginTop: '-0.5rem', marginBottom: '0.5rem' }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                  <div className="h-1rem d-flex align-items-center ms-5">
                    {s.pollMessage || "Polling for status..."}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (!s.pollInterval && s.pollMessage) {
      divMsg = (
        <div className="position-fixed top-0 bottom-0 start-0 end-0 bg-transparent bg-opacity-50 d-flex align-items-start justify-content-center z-3">
          <div className="bg-white border border-primary rounded-bottom w-99 h-5-6 overflow-auto d-flex flex-column px-5">
            <Banner key={`poll-message-banner`} title="Topup poll message" />
            <div className="d-flex flex-column align-items-center justify-content-center flex-grow-1">
              <div
                className={
                  s.toastColor === "success"
                    ? "alert alert-success w-100"
                    : "alert alert-danger w-100"
                }
              >
                <div className="d-flex align-items-center gap-2">
                  <div className="h-1rem d-flex align-items-center ms-5">
                    {s.pollMessage || "Please check with administrator."}
                  </div>
                </div>
              </div>
              <button
                className="btn btn-primary"
                type="button"
                onClick={() => this.setState({ pollMessage: "", msg: "" })}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 w-100 d-flex flex-column overflow-auto">
        {divMsg}
        <div className="w-100 flex-grow-1 px-5 d-flex flex-column align-items-center">
          {s.credits > 0 ? (
            <div className="w-100 max-w-3xl mt-8 mb-2 alert alert-success">
              <div className="row row-cols-2 g-4">
                {/* <div className="d-flex gap-1 border-bottom pb-2">
                <div className="fw-bold">Account Name:</div>
                <div>
                  {s.fullname || <span className="text-muted">-</span>}
                </div>
              </div> */}
                <div className="d-flex gap-1 border-bottom pb-2">
                  <div className="fw-bold">Bundle Name:</div>
                  <div>
                    {s.bundleName || <span className="text-muted">-</span>}
                  </div>
                </div>
                <div className="d-flex gap-1 border-bottom pb-2">
                  <div className="fw-bold">Available Credits:</div>
                  <div>
                    {s.credits || <span className="text-muted">-</span>}
                  </div>
                </div>
                {/* <div className="d-flex gap-1 border-bottom pb-2">
                <div className="fw-bold">Cost:</div>
                <div>{s.cost || <span className="text-muted">-</span>}</div>
              </div> */}
                <div className="d-flex gap-1 border-bottom pb-2">
                  <div className="fw-bold">Used Credits:</div>
                  <div>
                    {s.used || <span className="text-muted">-</span>}
                  </div>
                </div>
                <div className="d-flex gap-1 border-bottom pb-2">
                  <div className="fw-bold">Expiry Date:</div>
                  <div>
                    {s.expiryDate || <span className="text-muted">-</span>}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="w-100 max-w-3xl mt-8 mb-2 alert alert-danger">
              Account has no credits, please topup
            </div>
          )}
          <div className="w-100 d-flex justify-content-center my-2 gap-2">
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.handleRefresh}
            >
              Refresh Balance{" "}
              <i className="bi bi-arrow-clockwise" style={{ color: "white" }} />
            </button>
            {!s.pollInterval && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.handleTopupToggle}
              >
                Topup <i className="bi bi-wallet2" style={{ color: "white" }} />
              </button>
            )}
            {s.pollRefId && (
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.handleCheckStatus}
              >
                Check Payment Status{" "}
                <i className="bi bi-stopwatch" style={{ color: "white" }} />
              </button>
            )}
          </div>
        </div>
        {s.showTopup && (
          <div className="position-fixed top-0 bottom-0 start-0 end-0 bg-transparent bg-opacity-50 d-flex align-items-start justify-content-center z-3">
            <div className="bg-white border border-primary rounded-bottom w-99 h-5-6 overflow-auto d-flex flex-column px-5">
              <Banner key={`poll-message-banner`} title="Topup account" />
              <div className="d-flex flex-column align-items-center justify-content-center flex-grow-1">
                {divMsg}
                <form
                  onSubmit={this.handleTopupSubmit}
                  className="d-flex flex-column align-items-center gap-4"
                >
                  <div className="input-group w-32rem">
                    <label className="input-group-text">Bundle Name</label>
                    <select
                      name="topupBundleName"
                      className={`form-control ${s.topupErrors.topupBundleName ? " border-danger" : ""
                        }`}
                      value={s.topupBundleName}
                      onChange={(e) => {
                        const bundle = s.bundles[e.target.selectedIndex - 1];
                        this.setState(
                          {
                            topupCost: bundle?.cost || "",
                            topupCredits: bundle?.credits || 0,
                            topupCurrency: bundle?.currency || "",
                            topupBundleName: bundle?.name || "",
                            topupExpiryInDays: bundle?.expiryInDays || 0,
                          },
                          this.validateTopup
                        );
                      }}
                      required
                    >
                      <option value="">Select</option>
                      {s.bundles.map((bundle) => (
                        <option key={bundle.name} value={bundle.name}>
                          {bundle.name}
                        </option>
                      ))}
                    </select>
                    {s.topupErrors.topupBundleName && (
                      <span className="input-group-error">
                        {s.topupErrors.topupBundleName}
                      </span>
                    )}
                  </div>
                  {s.topupBundleName && (
                    <div className="alert alert-success w-32rem">
                      <div className="d-flex gap-1 justify-content-between">
                        <div className="fw-bold">Credits:</div>
                        <div>
                          {s.topupCredits || (
                            <span className="text-muted">-</span>
                          )}
                        </div>
                      </div>
                      <div className="d-flex gap-1 justify-content-between">
                        <div className="fw-bold">Expiry In Days:</div>
                        <div>
                          {s.topupExpiryInDays || (
                            <span className="text-muted">-</span>
                          )}
                        </div>
                      </div>
                      <div className="d-flex gap-1 justify-content-between">
                        <div className="fw-bold">Currency:</div>
                        <div>
                          {s.topupCurrency || (
                            <span className="text-muted">-</span>
                          )}
                        </div>
                      </div>
                      <div className="d-flex gap-1 justify-content-between">
                        <div className="fw-bold">Cost:</div>
                        <div>
                          {s.topupCost || (
                            <span className="text-muted">-</span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="input-group w-32rem">
                    <label className="input-group-text">
                      Mobile Money Number
                    </label>
                    <input
                      name="topupMobileMoneyNumber"
                      className={`form-control ${s.topupErrors.topupMobileMoneyNumber
                          ? "border-danger"
                          : ""
                        }`}
                      value={s.topupMobileMoneyNumber}
                      onChange={this.handleTopupChange}
                      required
                    />
                    {s.topupErrors.topupMobileMoneyNumber && (
                      <span className="input-group-error">
                        {s.topupErrors.topupMobileMoneyNumber}
                      </span>
                    )}
                  </div>
                  <div className="input-group w-32rem">
                    <label className="input-group-text">
                      Mobile Money Name
                    </label>
                    <select
                      name="topupMobileMoneyName"
                      className={`form-control ${s.topupErrors.topupMobileMoneyName
                          ? " border-danger"
                          : ""
                        }`}
                      value={s.topupMobileMoneyName}
                      onChange={(e) => {
                        this.setState(
                          {
                            topupMobileMoneyName:
                              s.mobileMoneyTypes[e.target.selectedIndex - 1] ||
                              "",
                          },
                          this.validateTopup
                        );
                      }}
                      required
                    >
                      <option value="">Select</option>
                      {s.mobileMoneyTypes.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                    {s.topupErrors.topupMobileMoneyName && (
                      <span className="input-group-error">
                        {s.topupErrors.topupMobileMoneyName}
                      </span>
                    )}
                  </div>
                  {s.pollStatus ? (
                    <div className="bg-light rounded p-2">
                      Status: {s.pollStatus}
                    </div>
                  ) : (
                    <div className="w-32rem"></div>
                  )}
                  <div className="w-100 d-flex justify-content-center gap-2 mb-2 mt-3">
                    {Object.keys(s.topupErrors).length === 0 && (
                      <button
                        type="submit"
                        className="btn btn-primary px-4"
                        disabled={!!s.pollRefId}
                      >
                        Submit Topup
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-primary px-4"
                      onClick={this.handleTopupToggle}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
